// app/frontend/components/conversation/BlurredMessage.tsx

import { cn } from '@/lib/utils'

interface BlurredMessageProps {
  isFromAgent: boolean
  content: string
}

export function BlurredMessage({ isFromAgent, content }: BlurredMessageProps) {
  return (
    <div className={cn(
      "flex gap-3 max-w-[80%] blur-[6px] select-none pointer-events-none opacity-50",
      isFromAgent && "ml-auto flex-row-reverse"
    )}>
      <div className="shrink-0 size-8 rounded-full bg-muted" />
      <div className="flex flex-col gap-1">
        <div className={cn(
          "rounded-2xl px-4 py-2",
          isFromAgent ? "bg-primary text-primary-foreground" : "bg-muted"
        )}>
          <p className="text-sm whitespace-pre-wrap">{content}</p>
        </div>
        <p className={cn(
          "text-xs text-muted-foreground",
          isFromAgent && "text-right"
        )}>
          ··· · ··:··
        </p>
      </div>
    </div>
  )
}
